// extracted by mini-css-extract-plugin
export default {"root":"ViewToggle_root__sojC-","button":"ViewToggle_button__sCvSu","buttonActive":"ViewToggle_buttonActive__zO1FG"};